import { DURATION_REQUIRED, parseDuration, type DurationReading } from './linked-time-fields';

/**
 * Read a Billable Hours box: the Duration box's grammar exactly
 * (`parseDuration`, decided 2026-09-09) — one grammar for every hours box in
 * the app, the Show entries cells and the Edit dialog included (HW-974 design,
 * decision 5) — with one difference: zero is a real answer here (an entry
 * billed at nothing), where a zero Duration is "This field is required".
 *
 * `parseDuration` answers a value that comes to zero, and only that, with
 * `DURATION_REQUIRED` — an empty box is `{ null, null }` — so that answer is
 * the zero. Its ceiling (under 24h) is the one the server holds
 * `billableDuration` to (`MAX_ENTRY_DURATION_SECONDS`), so nothing is added.
 *
 * Until HW-974 this module read every box as decimal hours (`readBillableHours`,
 * HW-892 / HW-973), which disagreed with the Duration box on `1.25` and
 * `2.50`; it is reduced to this wrapper so the two cannot disagree. [HW-974]
 */
export function readBillableDuration(raw: string): DurationReading {
  const reading = parseDuration(raw);
  if (reading.seconds === null && reading.error === DURATION_REQUIRED) {
    return { seconds: 0, error: null };
  }
  return reading;
}
